export const customsPostsQueryKeys = {
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
  fin: 'documentNumber',
  trackingNumber: 'trackingNumber',
  status: 'status',
};
